<template>
    <header class="py-3 h-16 w-full fixed left-0 top-0 z-40 bg-dark shadow-sm dark:bg-gray-800">
        <div
            class="flex items-center justify-between h-full px-6 mx-auto text-purple-600 dark:text-purple-300"
        >
            <img v-if="surveyLogo" class="max-h-full max-w-md" :src="surveyLogo" alt="Placeholder logo">
            <img v-else
                src="/images/logo-placeholder.jpg"
                alt="Placeholder logo"
                class="max-h-full max-w-md">
<!--            <ul class="flex items-center flex-shrink-0 space-x-6">
                &lt;!&ndash; Theme toggler &ndash;&gt;
                <li class="flex">
                    <button
                        class="rounded-md focus:outline-none focus:shadow-outline-purple"
                        @click="toggleTheme"
                        aria-label="Toggle color mode"
                    >
                        <template v-if="!dark">
                            <svg
                                class="w-5 h-5"
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    d="M17.293 13.293A8 8 0 016.707 2.707a8.001 8.001 0 1010.586 10.586z"
                                ></path>
                            </svg>
                        </template>
                        <template v-if="dark">
                            <svg
                                class="w-5 h-5"
                                aria-hidden="true"
                                fill="currentColor"
                                viewBox="0 0 20 20"
                            >
                                <path
                                    fill-rule="evenodd"
                                    d="M10 2a1 1 0 011 1v1a1 1 0 11-2 0V3a1 1 0 011-1zm4 8a4 4 0 11-8 0 4 4 0 018 0zm-.464 4.95l.707.707a1 1 0 001.414-1.414l-.707-.707a1 1 0 00-1.414 1.414zm2.12-10.607a1 1 0 010 1.414l-.706.707a1 1 0 11-1.414-1.414l.707-.707a1 1 0 011.414 0zM17 11a1 1 0 100-2h-1a1 1 0 100 2h1zm-7 4a1 1 0 011 1v1a1 1 0 11-2 0v-1a1 1 0 011-1zM5.05 6.464A1 1 0 106.465 5.05l-.708-.707a1 1 0 00-1.414 1.414l.707.707zm1.414 8.486l-.707.707a1 1 0 01-1.414-1.414l.707-.707a1 1 0 011.414 1.414zM4 11a1 1 0 100-2H3a1 1 0 000 2h1z"
                                    clip-rule="evenodd"
                                ></path>
                            </svg>
                        </template>
                    </button>
                </li>
            </ul>-->
        </div>
    </header>
</template>

<script>
export default {
    name: "SurveyTopBar",
    props: {
        surveyLogo: String,
    },
    methods: {
        toggleTheme() {
            this.dark = !this.dark;
            this.setThemeToLocalStorage(this.dark);
        },
    }
}
</script>

<style scoped>

</style>
